import normalizeText from '@/lib/normalizeText.js';

const toReadableGovernanceLabel = (value, fallback = '') => {
  const normalizedValue = normalizeText(value);

  if (!normalizedValue) {
    return fallback;
  }

  const spacedValue = normalizedValue
    .replace(/([a-z0-9])([A-Z])/gu, '$1 $2')
    .replace(/[_-]+/gu, ' ')
    .replace(/\s+/gu, ' ')
    .trim();

  if (!spacedValue) {
    return fallback;
  }

  return `${spacedValue.slice(0, 1).toUpperCase()}${spacedValue.slice(1)}`;
};

export default toReadableGovernanceLabel;
